module.exports = __webpack_public_path__ + "static/media/KaTeX_Fraktur-Regular.135ccd74.woff2";